import { Component, OnInit } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { AdminService } from '../../_services/admin.service';
import { StatusCode, UserStatusID } from '../../../_common/_enum/module.enum'; //USING IT IN HTML
import { RESULTS_NOT_FOUND } from 'src/app/_common/product-config';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent implements OnInit {

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  private resultsNotFound = RESULTS_NOT_FOUND;

  private loading: boolean = false;
  private oktaID = null;
  private userDetails;
  private resendActivationLoader: boolean = false;
  private sentActivationLoader: boolean = false;
  private failedActivationLoader:boolean = false;
  private hasAccess:boolean = false;

  constructor(private readonly route: ActivatedRoute, private router: Router, private adminService: AdminService) { }

  ngOnInit() {
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */

    //Getting Okta ID for State params
    this.route.paramMap.subscribe(params => {
      this.oktaID = params.get("id").toString();
      this.fetchUserDetails();
    });

  }
  setHeaderData(){
    this.headerData.pageTitle = (this.userDetails)?(this.userDetails.firstName + " " + this.userDetails.lastName):"";
    this.headerData.breadcrumb = [{itemName: "ADMIN", itemLink: "/admin"}];//, {itemName: this.userDetails.companyName, itemLink: "/admin/companies/"+ this.userDetails.companyID}];
    if(this.userDetails){
      this.headerData.breadcrumb.push({itemName: this.userDetails.companyName, itemLink: "/admin/company/"+ this.userDetails.companyID})
    }
    this.adminService.header = this.headerData;  
  }

  fetchUserDetails(){
    this.loading = true;
    let companyDetailsSubscription = this.adminService.fetchUserDetails(this.oktaID).subscribe((user:any)=>{
      this.loading = false;
      this.userDetails = user;
      if(this.userDetails != null){
        this.setHeaderData();
        
        let newProducerCodes = [];
        this.userDetails.producerCodes.forEach(_producerCode => {
          newProducerCodes.push({code: _producerCode, isSelected: true});
        });
        
        this.userDetails.producerCodesArray = newProducerCodes;
      }
    },error=>{
      this.loading = false;
      this.userDetails = null;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });
    this.adminService.runningServices.push(companyDetailsSubscription);
  }

  get UserStatusIDEnum(){
    return UserStatusID;
  }
  
  getUserStatusClass(status){
    return (status.toLowerCase() === "pending activation")?"pending-activation":(status.toLowerCase() === "on hold")?"on-hold":status.toLowerCase();
  }
  
  resendActivationLink(){
    this.resendActivationLoader = true;
    if(this.userDetails.statusID == UserStatusID.PendingActivation){
      this.adminService.resendActivationEmail(this.userDetails.emailID).subscribe(data=>{
        this.resendActivationLoader = false;
        if(data == true)
          this.sentActivationLoader = true;
        else 
          this.failedActivationLoader = true;
        
        setTimeout(()=>{
          this.sentActivationLoader = false;
          this.failedActivationLoader = false;
        }, 3000);
      },
      error => {
        this.resendActivationLoader = false;
        this.failedActivationLoader = true;

        setTimeout(()=>{
          this.failedActivationLoader = false;
        }, 3000);
        console.log("Resend Activation email Error : "+ error);
      });
    }
  }

  goToEditUser(){
    this.router.navigateByUrl("admin/user/" + this.oktaID + "/edit");
  }
  ngOnDestroy() {
    this.adminService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
